var map = {
	"./en.mjs": [
		39032,
		"node_modules_angular_common_locales_en_mjs"
	],
	"./extra/en.mjs": [
		18293,
		"node_modules_angular_common_locales_extra_en_mjs"
	],
	"node_modules/@angular/common/locales/en.mjs": [
		39032,
		"node_modules_angular_common_locales_en_mjs"
	],
	"node_modules/@angular/common/locales/extra/en.mjs": [
		18293,
		"node_modules_angular_common_locales_extra_en_mjs"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36715;
module.exports = webpackAsyncContext;